<div class="app flex-row align-items-center fade-in">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-group mb-0">
          <div class="card p-4 position-relative">
            @if (showLocalForm) {
              <div class="card-body">
                <form (ngSubmit)="submit()" [formGroup]="form">
                  <h1>Login</h1>
                  <p class="text-muted">Sign in to your account</p>
                  @if (production) {
                    <div class="alert alert-info" role="status">
                      @if (ssoMigrationDate) {
                        MyPayter will migrate to Keycloak sign-in on
                        {{ ssoMigrationDate }}.
                      } @else {
                        MyPayter will migrate to Keycloak sign-in soon.
                      }
                    </div>
                  }
                  @if (justLoggedOut) {
                    <div class="alert alert-success" role="status">
                      You have been signed out. Sign in again when you are
                      ready.
                    </div>
                  }
                  @if (ssoError) {
                    <div class="alert alert-danger" role="alert">
                      <i class="fa fa-lg fa-warning">&nbsp;</i
                      >{{ ssoError.message }}
                    </div>
                  }
                  @if (form.errors) {
                    <div class="alert alert-danger" role="alert">
                      <i class="fa fa-lg fa-warning">&nbsp;</i
                      >{{ form.errors.global }}
                    </div>
                  }
                  <div class="input-group mb-3 mb-3">
                    <span class="input-group-addon input-group-text"
                      ><i class="icon-user"></i
                    ></span>
                    <input
                      type="text"
                      class="form-control"
                      [class.is-invalid]="showFieldInvalid('username')"
                      placeholder="Username"
                      id="username"
                      name="username"
                      formControlName="username" />
                    @if (showFieldInvalid('username')) {
                      <div class="invalid-feedback">
                        Enter your account username.
                      </div>
                    }
                  </div>
                  <div class="input-group mb-4">
                    <span class="input-group-addon input-group-text"
                      ><i class="icon-lock"></i
                    ></span>
                    <input
                      [type]="isPasswordHidden ? 'password' : 'text'"
                      class="form-control"
                      placeholder="Password"
                      id="password"
                      name="password"
                      formControlName="password"
                      autocomplete="off" />
                    <button
                      class="btn btn-outline-secondary text-dark"
                      type="button"
                      (click)="togglePasswordHideShow()"
                      tabindex="-1">
                      <i
                        class="fa fa-lg"
                        [ngClass]="
                          isPasswordHidden ? 'fa-eye' : 'fa-eye-slash'
                        "></i>
                    </button>
                  </div>
                  <div class="input-group mb-4">
                    <span class="input-group-addon input-group-text"
                      ><i class="icon-home"></i
                    ></span>
                    <input
                      type="text"
                      class="form-control"
                      [class.is-invalid]="showFieldInvalid('domain')"
                      placeholder="Domain"
                      id="domain"
                      name="domain"
                      formControlName="domain" />
                    @if (showFieldInvalid('domain')) {
                      <div class="invalid-feedback">
                        Enter your account domain.
                      </div>
                    }
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <button
                        type="button"
                        type="submit"
                        [disabled]="form.invalid && !connectionError"
                        class="btn btn-primary px-4">
                        Login
                      </button>
                    </div>
                    <div class="col-6 text-end">
                      <a
                        class="btn btn-link px-0"
                        [routerLink]="['/login', 'forgot']"
                        >Forgot password?</a
                      >
                    </div>
                  </div>
                  @if (ssoEnabled) {
                    <hr />
                    <div class="row">
                      <div class="col-12">
                        <button
                          type="button"
                          (click)="loginWithSso()"
                          class="btn btn-outline-primary w-100">
                          <i class="icon-key">&nbsp;</i>Sign in with Keycloak
                        </button>
                      </div>
                    </div>
                  }
                </form>
              </div>
            } @else {
              <div class="card-body text-center py-5">
                <p class="text-muted mb-3">Redirecting to sign-in…</p>
                <loader-line></loader-line>
              </div>
            }
            @if (loading) {
              <loader-line></loader-line>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
